import { render } from "./notifications.vue?vue&type=template&id=5eac6fa5"
const script = {}
script.render = render

export default script